import LangEnum from '../../lang/LangEnum';

export type UserRole = 'ADMIN' | 'ADMIN_MARCA' | 'ADMIN_LOJA' | 'COMPRADOR' | 'VENDEDOR';

export type LicenseType = 'TECEO_MARCA' | 'TECEO_LOJA' | 'TECEO_SHOP' | 'TECEO_OMNI';

export type UserPosition =
  | 'BUYER'
  | 'OWNER'
  | 'SELLER'
  | 'MANAGER'
  | 'DIRECTOR'
  | 'SUPERVISOR'
  | 'COMMERCIAL_SUPPORT'
  | 'SALES_REPRESENTATIVE';

export const roles: Array<{ value: UserRole; label: LangEnum }> = [
  {
    value: 'ADMIN_MARCA',
    label: LangEnum.USER_ROLES_BRAND_ADMIN,
  },
  {
    value: 'ADMIN',
    label: LangEnum.USER_ROLES_ADMIN,
  },
  {
    value: 'ADMIN_LOJA',
    label: LangEnum.USER_ROLES_STORE_ADMIN,
  },
  {
    value: 'COMPRADOR',
    label: LangEnum.USER_POSITION_BUYER,
  },
  {
    value: 'VENDEDOR',
    label: LangEnum.USER_POSITION_SELLER,
  },
];

export const rolesUsersStore: Array<{ value: UserRole; label: string }> = [
  {
    value: 'ADMIN_LOJA',
    label: LangEnum.USER_ROLES_STORE_ADMIN,
  },
  {
    value: 'COMPRADOR',
    label: LangEnum.USER_POSITION_BUYER,
  },
];

export const rolesUsersBrand: Array<{ value: UserRole; label: string }> = [
  {
    value: 'ADMIN_MARCA',
    label: LangEnum.USER_ROLES_BRAND_ADMIN,
  },
  {
    value: 'VENDEDOR',
    label: LangEnum.USER_POSITION_SELLER,
  },
];

export const getRole = (role: UserRole) => {
  const filter = roles.filter((r) => r.value === role);
  return filter && filter[0] ? filter[0].label : role || '-';
};

export const licenses: Array<{ value: LicenseType; label: string }> = [
  {
    value: 'TECEO_LOJA',
    label: LangEnum.LICENSES_TECEO_STORE,
  },
  {
    value: 'TECEO_MARCA',
    label: LangEnum.LICENSES_TECEO_BRAND,
  },
  {
    value: 'TECEO_SHOP',
    label: LangEnum.LICENSES_TECEO_SHOP,
  },
  {
    value: 'TECEO_OMNI',
    label: LangEnum.LICENSES_TECEO_OMNI,
  },
];

export const getLicense = (license: LicenseType) => {
  const filter = licenses.filter((r) => r.value === license);
  return filter && filter[0] ? filter[0].label : '-';
};

export const userPositions: Array<{ value: UserPosition; label: string }> = [
  {
    value: 'OWNER',
    label: LangEnum.USER_POSITION_OWNER,
  },
  {
    value: 'DIRECTOR',
    label: LangEnum.USER_POSITION_DIRECTOR,
  },
  {
    value: 'MANAGER',
    label: LangEnum.USER_POSITION_MANAGER,
  },
  {
    value: 'SUPERVISOR',
    label: LangEnum.USER_POSITION_SUPERVISOR,
  },
  {
    value: 'COMMERCIAL_SUPPORT',
    label: LangEnum.USER_POSITION_COMMERCIAL_SUPPORT,
  },
  {
    value: 'BUYER',
    label: LangEnum.USER_POSITION_BUYER,
  },
  {
    value: 'SELLER',
    label: LangEnum.USER_POSITION_SELLER,
  },
  {
    value: 'SALES_REPRESENTATIVE',
    label: LangEnum.USER_POSITION_SALES_REPRESENTATIVE,
  },
];

export const userBrandPositions: Array<{ value: UserPosition; label: string }> = [
  {
    value: 'OWNER',
    label: LangEnum.USER_POSITION_OWNER,
  },
  {
    value: 'DIRECTOR',
    label: LangEnum.USER_POSITION_DIRECTOR,
  },
  {
    value: 'MANAGER',
    label: LangEnum.USER_POSITION_MANAGER,
  },
  {
    value: 'SUPERVISOR',
    label: LangEnum.USER_POSITION_SUPERVISOR,
  },
  {
    value: 'COMMERCIAL_SUPPORT',
    label: LangEnum.USER_POSITION_COMMERCIAL_SUPPORT,
  },
  {
    value: 'SELLER',
    label: LangEnum.USER_POSITION_INNER_SELLER,
  },
  {
    value: 'SALES_REPRESENTATIVE',
    label: LangEnum.USER_POSITION_SALES_REPRESENTATIVE,
  },
];

export const userStorePositions: Array<{ value: UserPosition; label: string }> = [
  {
    value: 'OWNER',
    label: LangEnum.USER_POSITION_OWNER,
  },
  {
    value: 'DIRECTOR',
    label: LangEnum.USER_POSITION_DIRECTOR,
  },
  {
    value: 'MANAGER',
    label: LangEnum.USER_POSITION_MANAGER,
  },
  {
    value: 'SUPERVISOR',
    label: LangEnum.USER_POSITION_SUPERVISOR,
  },
  {
    value: 'BUYER',
    label: LangEnum.USER_POSITION_BUYER,
  },
];

export const getUserPosition = (position: UserPosition) => {
  const filter = userPositions.filter((userPosition) => userPosition.value === position);
  return filter && filter[0] ? filter[0].label : '-';
};
